module.exports = __webpack_public_path__ + "static/media/20110524_4519.80e1dc43.jpg";